import ApiUtils from "../utils/ApiUtils";

class GeneralApis {

    public static getPreFillData = (params: any, preFillConfig: any, hyphenated: boolean): Promise<any> => {
        const paramsString = params ?
            ApiUtils.requestToQueryParams(params, hyphenated)
            : "";
        const url = `${preFillConfig.url}?${paramsString}`;
        return ApiUtils.apiGetRequest(url, false, 1000);
    }

}

export default GeneralApis